import React from 'react';

export const AnalysisView: React.FC = () => {
    return <p>AnalysisView</p>;
};
